const PAGE_NAME = 'selectWorkerPage';

export const SELECT_WORKER_STAGE_SUBMITTED = `${PAGE_NAME}/SELECT_WORKER_STAGE_SUBMITTED`;
export const SELECT_PREFERRED_WORKER = `${PAGE_NAME}/SELECT_PREFERRED_WORKER`;
